<template>
  <w-modal :value="value" @close="$emit('input', false)">
    <h1 slot="header">批次新增品項</h1>
    <div slot="content" class="modal-content">
      <div class="border-b border-blue-200 flex items-end pb-2">
        <a
          class="border border-blue-500 hover:text-blue-500 mr-2 p-2 rounded text-blue-500 text-xs"
          href="/files/好彙訂-批次匯入菜單品項範例.csv"
          download
        >
          下載範本
        </a>
        <span class="modal-content__description">
          範例中包含品項的必要欄位。
        </span>
      </div>
      <div class="w-[650px]">
        <b-upload
          v-model="file"
          accept=".csv"
          expanded
          drag-drop
        >
          <div class="m-4 text-center">
            <i class="icon-upload text-4xl" />
          </div>
          <p class="mb-2 text-center">{{ file ? file.name : '點擊此處選擇檔案或直接拖曳檔案至此' }}</p>
          <p class="upload__description--muted">檔案格式僅限csv</p>
        </b-upload>
      </div>
    </div>
    <div slot="footer">
      <w-button class="mr-2" type="link">
        取消
      </w-button>
      <w-button :disabled="!file" @click="onAdd">
        上傳檔案
      </w-button>
    </div>
  </w-modal>
</template>

<script>
import AddMultipleMenuItems from './AddMultipleMenuItems';

export default AddMultipleMenuItems;
</script>

<style lang="scss" scoped>
@import 'AddMultipleMenuItems';
</style>
